import { useGetCustomerVouchers } from './useGetCustomerVouchers'
import { Voucher } from './Voucher'
import { VoucherCartHeader } from './VoucherCartHeader'
import Separator from '../layout/Separator'
import Loader from '../presentation/Loader'

export const CustomerCouponVouchers = () => {
    const { loading, salesRuleVouchers, customerCoupons } =
        useGetCustomerVouchers({
            skipFreeGifts: true,
        })

    const vouchers = [...salesRuleVouchers, ...customerCoupons]

    return loading ? (
        <Loader />
    ) : (
        <>
            <VoucherCartHeader numberOfVouchers={vouchers.length} />
            {vouchers.length > 0 && <Separator />}

            {vouchers.map((voucher) => (
                <Voucher key={voucher.couponId} voucher={voucher} showButtons />
            ))}
        </>
    )
}
